import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-cx-interaction',
  template: `
    <div style="float: left; margin-right: 10px;">
        <mat-icon>label_outline</mat-icon>
    </div>
    <div>
      <div class="description tw-pt-1">
        <span ng-bind-html="activity.activityHtml"></span>
        <strong class="tw-text-sm">CX Interaction - {{activity.meta['interactionType']}}</strong>
        <div class="text tw-pt-1 tw-px-9">
           {{ activity.meta['sentiment'] }}, {{ activity.meta['interactionOutcome'] }} reported by {{ activity.meta['lenderUserName'] }}
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-px-9 tw-pt-3">
            <div class="tw-pr-5">
                <strong>Tag(s):</strong>
                <div class="tw-w-full tw-pt-1">
                <mat-chip-listbox class="is-list tw-flex">
                    <div class="tw-grid tw-grid-cols-1 tw-gap-2">
                        <div>
                            <mat-chip-option *ngFor="let tag of activity.meta['tags']" class="tw-text-xs">{{ tag }}</mat-chip-option>
                        </div>
                    </div>
                </mat-chip-listbox>
                </div>
            </div>
            <div class="tw-w-48">
                <strong>Funnel:</strong>
                <div class="text tw-pt-1">
                    {{ activity.meta['funnelStatus']}}
                </div>
            </div>

            <div class="tw-pr-5 tw-pt-3">
                <strong>Note:</strong>
                <div class="text tw-pt-1 tw-max-w-lg">
                    {{ activity.meta['note']}}
                </div>
            </div>
            <div class="tw-w-48 tw-pt-3">
                <strong>App Complete:</strong>
                <div class="text tw-pt-1">
                    {{ activity.meta['appStatus']}}
                </div>
            </div>
            </div>
        </div>
    </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowCxInteractionComponent {
  @Input() activity;
}
